export default {"src":"/_next/static/media/question.a907bcdf.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};